// src/api/dashboard.ts - COMPLETE FIXED VERSION WITH CONSISTENT STATS
import { api } from './client';
import type { ApiResponse, User, Order, Notification, PaginationData } from '../types';
import type { QuickOffer } from '../types/order.types';

export const dashboardAPI = {
  health: () => api.get<ApiResponse>('/api/dashboard/health'),
  
  getCustomerDashboard: () =>
    api.get<ApiResponse<{
      stats: {
        totalOrders: number;
        activeOrders: number;
        totalSpent: number;
        averageRating: number;
        recentOrders?: Order[];
        quickOffers?: QuickOffer[];
      };
      profile?: User;
      recentOrders?: Order[];
      quickOffers?: QuickOffer[];
      notifications?: Notification[];
    }>>('/api/dashboard/customer'),
  
  getRiderDashboard: () =>
    api.get<ApiResponse<{
      stats: {
        todayEarnings: number;
        todayRides: number;
        thisWeekEarnings: number;
        thisWeekRides: number;
        thisMonthEarnings: number;
        thisMonthRides: number;
        totalEarnings: number;
        totalRides: number;
        averageRating: number;
        acceptanceRate: number;
        completionRate: number;
        averageResponseTime: number;
        activeOrders: number;
        pendingOrders: number;
        completedOrders: number;
        cancelledOrders: number;
        activeListings: number;
        urgentOrders: number;
      };
      profile?: User;
      activeOrders?: Order[];
      pendingOrders?: Order[];
      recentEarnings?: Array<{
        _id: string;
        orderId: string;
        orderNumber: string;
        routeAxis: string;
        riderPayout: number;
        createdAt: string;
        customerName: string;
      }>;
      notifications?: Notification[];
    }>>('/api/dashboard/rider'),
  
  getProfile: () => api.get<ApiResponse<{ user: User; roleData: Record<string, unknown> }>>('/api/dashboard/profile'),
  
  getSummary: () => api.get<ApiResponse<{ summary: Record<string, unknown> }>>('/api/dashboard/summary'),
  
  updateProfile: (data: Partial<User>) =>
    api.put<ApiResponse<{ user: User }>>('/api/dashboard/profile', data),
  
  setupProfile: (data: { 
    role: string; 
    phone?: string; 
    location?: { city: string; area?: string };
    bikeInfo?: {
      model?: string;
      plateNumber?: string;
      color?: string;
      year?: string;
    };
  }) => api.post<ApiResponse<{ user: User; redirectTo: string }>>('/api/dashboard/setup-profile', data),
  
  uploadProfileImage: (formData: FormData) =>
    api.post<ApiResponse<{ imageUrl: string }>>('/api/dashboard/profile/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  uploadBikeImage: (formData: FormData) =>
    api.post<ApiResponse<{ imageUrl: string }>>('/api/dashboard/bike/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  
  getActivityLog: (params?: { page?: number; limit?: number }) =>
    api.get<ApiResponse<{ 
      activities: Array<{
        id: string;
        type: string;
        description: string;
        timestamp: string;
        metadata?: Record<string, unknown>;
      }>; 
      pagination: PaginationData 
    }>>('/api/dashboard/activity', { params }),
};

export default dashboardAPI;